import apiClient from '../client';

/** One row of api_staff_attendance_logs — today's punch state. */
export interface StaffAttendanceLog {
  id: number;
  staff_id: number;
  user_id: number | null;
  branch_slug: string | null;
  work_date: string;
  punch_in_at: string;
  punch_out_at: string | null;
  punch_in_note: string | null;
  punch_out_note: string | null;
}

export interface StaffAttendanceStatus {
  status: 'in' | 'out';
  log: StaffAttendanceLog | null;
}

const BASE = '/admin/staff-attendance';

export const staffAttendanceApi = {
  /** Current punch state for the authenticated user (today only). */
  status: () =>
    apiClient.get<{ data: StaffAttendanceStatus }>(`${BASE}/status`).then((r) => r.data.data),

  /**
   * Create today's punch-in row.  Idempotent — if an open row already
   * exists it is returned unchanged.  409 if the day has already been
   * closed out.
   */
  punchIn: (note?: string) =>
    apiClient.post<{ data: StaffAttendanceLog }>(`${BASE}/punch-in`, { note }).then((r) => r.data.data),

  /** Close today's open row.  404 if nothing to close; 409 if already closed. */
  punchOut: (note?: string) =>
    apiClient.post<{ data: StaffAttendanceLog }>(`${BASE}/punch-out`, { note }).then((r) => r.data.data),
};

